import { Component, ContentChildren, EventEmitter, forwardRef, HostBinding, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges } from '@angular/core';
import { Bs5TabPanelComponent } from './bs5-tab-panel.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'bs5-tab',
  templateUrl: './bs5-tab.component.html',
  styleUrls: ['./bs5-tab.component.scss'],
  host: { '[class.tabbable]': 'true' },
  standalone: true,
  imports: [CommonModule],
})
export class Bs5TabComponent implements OnInit, OnChanges {

  // child panes array
  @ContentChildren(forwardRef(() => Bs5TabPanelComponent))
  panels!: QueryList<Bs5TabPanelComponent>;

  constructor() {
  }

  @Input() selectedIdx = 0;
  @Output() selectedIdxChange = new EventEmitter<any>();

  // selects the specified pane
  select(panel: Bs5TabPanelComponent, ignoreDisabled = false) {

    if (!ignoreDisabled && panel.disabled) {
      return;
    }
    
    var panels = this.panels.toArray();
    for (let e of panels) {
      e.selected = false;
    }
    panel.selected = true;
    this.selectedIdxChange.emit(panels.indexOf(panel));
  }

  selectByIndex(idx: number) {
    let panel = this.panels.get(idx);
    if (panel) {
      this.select(panel, true);
    }
  }

  ngAfterContentInit() {
    // selects first pane after load
    setTimeout(() => {
      if (this.panels.length) {
        if (this.selectedIdx === 0) {
          this.select(this.panels.first);
        } else {
          let panel = this.panels.get(this.selectedIdx);
          if (panel) {
            this.select(panel);
          }
        }
      }
    }, 50)
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('aaaa');
    // if (changes['selectedIdx'] && !changes['selectedIdx'].firstChange) {
    //   let panel = this.panels.get(this.selectedIdx);
    //   if (panel) {
    //     this.select(panel);
    //   }
    // }
  }

  ngOnInit(): void {
  }

}
